var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconProperties = function SvgIconProperties(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.18 4.5q-.743 0-1.211.469-.47.468-.469 1.21V17.82q0 .743.469 1.211.468.47 1.21.469H17.82q.743 0 1.211-.469.47-.469.469-1.21V6.18q0-.743-.469-1.211-.469-.47-1.21-.469zm0 1.68h11.64v11.64H6.18zm1.64 1.64V9.5h8.36V7.82zm0 3.36v1.64h8.36v-1.64zm0 3.32v1.68h5.86V14.5z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconProperties);
export { ForwardRef as ReactComponent };